import React, { useState, lazy, Suspense } from "react";
import Login from "./layout/Login";
import Start from "./layout/user/Start";
import PersonalInfo from "./layout/user/PersonalInfo";
import Home from "./layout/Home";
import Where from "./layout/where";
import WhenShop from "./layout/whenShop";
import Error from "./layout/Error";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import NewShopPassword from "./layout/NewShopPassword.jsx";
import ProtectedRoutes from "./utils/ProtectedRoutes.jsx";
import PublicRoutes from "./utils/PublicRoutes.jsx";

// Heavy routes: loaded lazily so they don't inflate the initial bundle.
const Checkout           = lazy(() => import("./layout/checkout/index.jsx"));
const WhereToDeliver     = lazy(() => import("./layout/where/whereDeliver/index.jsx"));
const DeliveryDetails    = lazy(() => import("./layout/where/deliveryDetails/index.jsx"));
const CollectionPoints   = lazy(() => import("./layout/where/cpDetails/index.jsx"));
const OrderConfirmation  = lazy(() => import("./layout/OrderConfirmation.jsx"));
const RetriveCheckout    = lazy(() => import("./layout/checkout/retrieveCheckout/retriveCheckout.jsx"));
const RetrieveSuccess    = lazy(() => import("./layout/checkout/retrieveCheckout/retrieveSuccess.jsx"));
const PrinterSetting     = lazy(() => import("./layout/printer/index.jsx"));
const CheckoutTransactions = lazy(() => import("./layout/CheckoutTransactions/index.jsx"));
const PaymentDetails     = lazy(() => import("./layout/CheckoutTransactions/paymentDetails"));

const App = () => {
  // Lift the state up to the App component
  const [transactions, setTransactions] = useState([]);

  // Function to update transaction confirmation status
  const updateTransactionConfirmation = (id) => {
    setTransactions((prevTransactions) =>
      prevTransactions.map((transaction) =>
        transaction.id === id
          ? { ...transaction, confirmed: true }
          : transaction
      )
    );
  };

  const router = createBrowserRouter(
    [
      {
        path: '/',
        element: <ProtectedRoutes />,
        children: [
          {
            path: '/',
            element: <Home />
          },
          {
            path: 'start',
            element: <Start />
          },
          {
            path: 'personalinfo',
            element: <PersonalInfo />
          },
          {
            path: 'where',
            element: <Where />
          },
          {
            path: 'printerSetting',
            element: <Suspense fallback={null}><PrinterSetting /></Suspense>
          },
          {
            path: 'checkoutTransactions',
            element: (
              <Suspense fallback={null}>
                <CheckoutTransactions
                  transactions={transactions}
                  setTransactions={setTransactions}
                />
              </Suspense>
            )
          },
          {
            path: 'paymentDetails',
            element: (
              <Suspense fallback={null}>
                <PaymentDetails
                  updateTransactionConfirmation={updateTransactionConfirmation}
                />
              </Suspense>
            )
          },
          {
            path: 'deliverydetails',
            element: <Suspense fallback={null}><DeliveryDetails /></Suspense>
          },
          {
            path: 'collectionpoints',
            element: <Suspense fallback={null}><CollectionPoints /></Suspense>
          },
          {
            path: 'whenshop',
            element: <WhenShop />
          },
          {
            path: 'wheretodeliver',
            element: <Suspense fallback={null}><WhereToDeliver /></Suspense>
          },
          {
            path: 'checkout',
            element: <Suspense fallback={null}><Checkout /></Suspense>
          },
          {
            path: 'retrivecheckout',
            element: <Suspense fallback={null}><RetriveCheckout /></Suspense>
          },
          {
            path: 'orderconfirmation',
            element: <Suspense fallback={null}><OrderConfirmation /></Suspense>
          },
          {
            path: 'retrievesuccess',
            element: <Suspense fallback={null}><RetrieveSuccess /></Suspense>
          }
        ],
      },
      { 
        path: 'user/login', 
        element: <PublicRoutes />, 
        children: [
          {
            path: '',
            element: <Login />
          }
        ]
      },
      // Invite link from the admin panel: {POS_URL}/new-shop-password?token=…
      // Outside both guards on purpose — ProtectedRoutes would send a visitor
      // to the login screen, and PublicRoutes bounces an authenticated till to
      // /start, but this link is often opened on a till already signed in as
      // another shop.
      { path: 'new-shop-password', element: <NewShopPassword /> },
      { path: '*', element: <Error /> },
    ]
  );

  return (
    <RouterProvider router={router} />
  );
};

export default App;
